import React, { useState, useEffect } from "react";

const SplashScreenCommunityPartners = () => {
  const [communityPartners, setCommunityPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(
      "https://api.airtable.com/v0/appZGpRTkEij893tS/Community%20Partners?maxRecords=50&view=Grid+view",
      {
        headers: {
          authorization: "Bearer keyNfd02JL9fMEUlx",
          "x-airtable-application-id": "appZGpRTkEij893tS",
          "content-type": "application/json",
          "x-airtable-user-agent": "Airtable.js/undefined",
        },
        method: "GET",
        mode: "cors",
      }
    )
      .then((res) => res.json())
      .then((json) => {
        setCommunityPartners(json.records.map((partner) => partner.fields));
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <>
      {!loading &&
        communityPartners.map((communityPartner, index) => (
          <img
            src={communityPartner.logo_url}
            alt={`${communityPartner.community_name} logo`}
          />
        ))}
    </>
  );
};

export default SplashScreenCommunityPartners;
